import wwwRoutes from './www';
// import adminRoutes from './admin';

import url from 'url';

// Global areas of the app
// Example subdomain configuration below with 'admin'
const areas = {
  www: {
    name: 'www',
    routes: wwwRoutes,
    hosts: {
      production: '', // prod portal url
      staging: '', // qa/staging portal url
      development: 'localhost:3000/', // localhost || adamspractice.portal-dev:8181/
    },
  },
  // admin: {
  //   name: 'admin',
  //   routes: adminRoutes,
  //   hosts: {
  //     production: '',
  //     staging: '',
  //     development: 'admin.adamspractice.portal-dev:8181/',
  //   },
  // },
};

const hostname = window.location.hostname.toLowerCase();
let detectedArea = areas.www;
let detectedEnv = 'development';
for (const name in areas) {
  if (areas[name].hosts) {
    for (const envName in areas[name].hosts) {
      if (areas[name].hosts[envName] === hostname) {
        detectedEnv = envName;
        detectedArea = areas[name];
      }
    }
  }
}
const currentEnv = detectedEnv;
const currentArea = detectedArea;

function resolveHref({ area, path, query, hash }) {
  // const fromArea = currentArea;
  // const toArea = areas[area || 'www'];
  // const isCrossAreaLink = (fromArea !== toArea);

  const urlData = {
    pathname: typeof path === 'string' ? path : '/',
    query,
    hash,
  };

  // @TODO: not sure yet...
  // if (isCrossAreaLink) {
  //   urlData.hostname = toArea.hosts[currentEnv];
  //   const port = window.location.port;
  //   if (port !== 80 || port !== 443) {
  //     // We need to handle 8181 and 8443 ports
  //     urlData.port = port;
  //   }
  // }

  return url.format(urlData);
}

export {
  currentEnv,
  currentArea,
  resolveHref,
  areas as default,
};



// WEBPACK FOOTER //
// ./src/routes/areas.js